import ForPartners from './ForPartners';

export default ForPartners;